module.exports = __webpack_public_path__ + "static/media/washington-dc-39.49e30a43.jpg";